import { FindADealerProps, IFindADealerFields } from '../types/findDealer.types';
import { ImageField, LinkField, StringField, TComponentParamsGeneral, THeadingTag } from '../../../types/types';

export class FindADealerModel {
  private readonly fields: null | IFindADealerFields;
  private readonly _props: null | FindADealerProps;
  private readonly params?: TComponentParamsGeneral;

  constructor(props: FindADealerProps) {
    this._props = props || null;
    this.fields = props?.fields || null;
    this.params = props?.params;
  }

  get id(): string | undefined {
    return this._props?.rendering?.dataSource;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get content(): StringField | undefined {
    return this.fields?.description;
  }

  get inputPlaceholder(): StringField | undefined {
    return this.fields?.searchPlaceholderText;
  }

  get inputPlaceholderText(): string {
    return this.inputPlaceholder?.value || '';
  }

  get searchButton(): LinkField | undefined {
    return this.fields?.link;
  }

  get backgroundImage(): ImageField | undefined {
    return this.fields?.image;
  }

  get mobileBackgroundImage(): ImageField | undefined {
    return this.fields?.mobileImage;
  }

  get locateMeButton(): StringField | undefined {
    return this.fields?.locationButtonText;
  }

  get searchButtonText(): string {
    return this.searchButton?.value?.text ?? '';
  }

  get searchUrl(): string {
    return this.searchButton?.value?.href ?? '#';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }
}
